import type { WavespeedModelConfig } from '../types';
import { clampTo, hasImageInput } from '../../tools';

export const microsoftConfigs: Record<string, WavespeedModelConfig> = {
    'microsoft/mai-image-2.5/text-to-image': {
        // https://wavespeed.ai/zh-CN/models/microsoft/mai-image-2.5/text-to-image
        apiPath: '/microsoft/mai-image-2.5/text-to-image',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                size: clampTo(aspectRatio || '1:1', ['21:9', '16:9', '9:16', '5:4', '4:5', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '1:1'),
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg', 'webp'] as const,
                    'png',
                ),
            };
        },
    },
    'microsoft/mai-image-2.5/edit': {
        // https://wavespeed.ai/zh-CN/models/microsoft/mai-image-2.5/edit
        apiPath: '/microsoft/mai-image-2.5/edit',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                size: aspectRatio === 'match' ? 'auto' : clampTo(aspectRatio || 'auto', ['auto', '16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, 'auto'),
                // 图片 URL
                image: image_urls[0],
                // 可选参数
                output_format: clampTo(
                    providerOptions?.output_format || 'png',
                    ['png', 'jpeg', 'webp'] as const,
                    'png',
                ),
            };
        },
    },
};